// Module
var code = "<section class=\"video-share-help-wrapper\" role=\"alert\" aria-live><p translate=\"activity-editor-new_video-share-help\"></p></section>";
// Exports
module.exports = code;